import { faClose } from "@fortawesome/pro-regular-svg-icons";

import Icon from "common/components/Icon";

import TextChip, { TextChipProps } from "client/common/components/content/TextChip";

import { SearchFilterOption } from "../types";

type SearchFilterTagsProps<T extends string | number | boolean> = {
  options: SearchFilterOption<T>[];
  value: T[];
  onChange: (value: T[]) => void;
  variant?: TextChipProps["variant"];
};

const SearchFilterTags = <T extends string | number | boolean>({
  options,
  value,
  onChange,
  variant = "primary",
}: SearchFilterTagsProps<T>) => {
  const valueSet = new Set(value);
  const activeOptions = options.filter((o) => valueSet.has(o.value));
  return (
    <>
      {activeOptions.map((option) => (
        <TextChip variant={variant} key={`${option.label}-${option.value}`}>
          {option.label}
          <button
            type="button"
            aria-label={`Remove ${option.label} filter`}
            onClick={() => onChange(value.filter((v) => v !== option.value))}
          >
            <Icon icon={faClose} />
          </button>
        </TextChip>
      ))}
    </>
  );
};

export default SearchFilterTags;
